export const UpdateOrganisations = (val) => {
    return {
        type: 'MAIN_UPDATE_ORGANISATIONS',
        value: val
    };
}